export default "__VITE_ASSET__DEXmX9oz__"